/* eslint-disable class-methods-use-this */
import ActivitiesApi from "../API/activities"
import { Service } from "./Service"

class ActivitiesService extends Service {
    private static instance: ActivitiesService

    constructor() {
        super()
        // set le nom du service
        this.name = "ActivitiesService"
        // ajoute la methode au mapping du site
        this.serviceMap.push({ key: "getActivities", fct: this.getActivities })
    }

    /*
     * Récupération de l'instance
     */
    public static getInstance(): ActivitiesService {
        if (!this.instance) {
            this.instance = new ActivitiesService()
        }
        return this.instance
    }

    /**
     * @param  {string}
     * @param  {string}
     * @return {Promise<any>}
     */
    public async getActivities(
        format: string,
        userId: string,
        startDate?: string,
        endDate?: string
    ): Promise<any> {
        let result
        try {
            result = await ActivitiesApi.getActivities(
                format,
                userId,
                startDate,
                endDate
            )
        } catch (err: any) {
            return null
        }
        return result.data
    }
}

export default ActivitiesService
